import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamTRTR() {
  return (
    <div className={styles["declaration"]}>
      <h1>Saha Personeli Eğitimi ve Sınavı Uyum Beyanı</h1>

      <p>
        Ön saflardaki üçüncü taraf tanıtım elemanlarının hizmet kalitesini sürekli artırmak amacıyla, Xiaomi Uluslararası Departman Eğitim Ekibi (bundan sonra "biz" veya "şirketimiz" olarak anılacaktır), hizmet sağlayıcıları tarafından belirlenen üçüncü taraf tanıtım elemanlarına (bundan sonra "katılımcılar" olarak anılacaktır) eğitim kursları ve bilgi pekiştirme sınavları sunar. Eğitim ve sınavın amacı kurs içeriğini optimize etmek ve öğrenme çıktılarını güçlendirmektir; herhangi bir iş ilişkisi veya fiili yönetim davranışı oluşturmaz. İşte eğitim ve sınavla ilgili beyan:
      </p>

      <ol>
        <li>
          <strong>Eğitim ve sınavın niteliği</strong><br/>
          Tüm eğitim kursları ve sınavlar, katılımcıların ürün bilgileri ve hizmet standartlarını sistematik olarak anlamalarına yardımcı olmayı amaçlayan bilgi paylaşımı için yapılır. Sınav sonuçları yalnızca katılımcıların eğitim içeriğini kavrama düzeyini yansıtır ve performans değerlendirmesi için temel oluşturamaz; bizim hizmet sağlayıcılarının katılımcılarla ilgili performans değerlendirmelerine, maaş dağılımına veya diğer iş ilişkisi konularına müdahale yetkimiz yoktur ve müdahale edilmeyecektir.
        </li>
        <li>
          <strong>Yasal ilişkinin netleştirilmesi</strong><br/>
          Katılımcılar ile ilgili hizmet sağlayıcıları arasındaki işveren-çalışan ilişkisi bu programdan etkilenmez. Şirketimiz ile katılımcılar arasında işveren-çalışan ilişkisi yoktur ve bu program fiili bir iş ilişkisi yaratmaz.
        </li>
        <li>
          <strong>Sınav sonuçlarının kullanımı</strong><br/>
          Sınav sonuçları yalnızca şu amaçlarla kullanılacaktır:
          <ol type="1">
            <li>Şirket içi kurs iyileştirmeleri için referans;</li>
            <li>Hizmet sağlayıcılarına katılımcıların uzmanlık kanıtı olarak sunulması (sağlayıcının bağımsız değerlendirmesine tabi);</li>
            <li>Sonuçlar üçüncü şahıslarla paylaşılmaz.</li>
          </ol>
        </li>
      </ol>

      <p>
        Bu beyan yayım tarihinde yürürlüğe girer. Programa katılım, katılımcıların beyanı kabul ettiği anlamına gelir. Şirketimiz yorum ve makul değişiklik hakkını saklı tutar.
      </p>

      <div className={styles["footer"]}>
        Xiaomi Uluslararası Departman Eğitim Ekibi<br/>
        Tarih: {getLocalizedTime('tr-TR')}
      </div>
    </div>
  );
}